module.exports = {
      id: "plan_print-usage",
      viewBox: "0 0 353.6 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#plan_print-usage",
      toString: function () {
        return this.url;
      }
    }